<template>
    <div class="engagement-info__logo-view" >
        <TransitionGroup name="fade" tag='div' class="logo-grid">
            <a v-for="(org, index) in orgs" :key="org.id" :href="'/organization/' + org.slug" @click.prevent="handleItemClick(index)" class="logo-grid__item">
                <img v-if="org.logo.logo_image" :src="org.logo.logo_image" :alt="'Logo for ' + org.name" :style="'transform: scale(' + org.logo.logo_width_percent/100 +  ')'">
                <div v-else class="logo-grid__text-logo">
                    {{org.name}}
                </div>
            </a>
        </TransitionGroup>
        
    </div>
</template>

<script setup>
    import {defineEmits} from 'vue'
    
    const props = defineProps({
        orgs: Array
    })
    const emits = defineEmits(['itemClicked'])

    const handleItemClick = (index) => {
        emits('itemClicked', index)
    }
</script>
